import { useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/hero/HeroSection';
import GallerySection from '../components/gallery/GallerySection';
import Toast from '../components/ui/Toast';
import { useToast } from '../hooks/useToast';

export default function HomePage() {
  const { toast, showToast, hideToast } = useToast();
  const [galleryRef, setGalleryRef] = useState<HTMLDivElement | null>(null);

  const scrollToGallery = () => {
    galleryRef?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen aurora-background text-lovable-text-primary selection:bg-lovable-red/30">
      <Header onGalleryClick={scrollToGallery} />
      <main className="flex-1 relative z-10">
        <HeroSection onSubmit={() => showToast('This can only be used by agents, not humans')} />
        <div ref={setGalleryRef}>
          <GallerySection />
        </div>
      </main>
      <Footer />
      <Toast message={toast} onClose={hideToast} />
    </div>
  );
}
